import PageTitle from "../../../layouts/PageTitle";
import React, { useState, Fragment, useEffect, useCallback  } from "react";
import Select from "react-select";
import {
   getCroppedImg,
   UpdateTheme,
   DeleteImage
} from './Requests';
import './Theme.css'
import Cropper from 'react-easy-crop';
import { ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  notifyError,
  notifySuccess
} from '../Response/ResposeHandler'
import {PulseLoader } from "react-spinners";
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { ForkLeft } from "@mui/icons-material";
import Button from '@mui/material/Button';


const themes = [
  { value: 1, label: 'Beige Theme' },
  { value: 2, label: 'White and Grey Theme' },
]

const Theme = (props) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppingFor, setCroppingFor] = useState(null);
  const [logo, setLogo] = useState("data:image/jpeg;base64," + props.site.logoImage);
  const [header, setHeader] = useState("data:image/jpeg;base64," + props.site.headerImage);
  const [theme, setTheme] = useState(themes.filter(x => x.value === props.site.themeId)[0]);
  const [saveThemeButtonLoading, setSaveThemeButtonLoading] = useState(false)

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleImageChange = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImageSrc(imageUrl);
      setCroppingFor(type);
    }
  };
  const handleCropDone = async () => {
    const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
    if (croppingFor === 'logo') {
      setLogo(croppedImage);
    } else if (croppingFor === 'header') {
      setHeader(croppedImage);
    }
    // Reset cropping state
    setImageSrc(null);
    setCroppingFor(null);
  };

  const handleCropCancel = () => {
  setImageSrc(null);
  setCroppingFor(null);
  setCrop({ x: 0, y: 0 });
  setZoom(1);
  setCroppedAreaPixels(null);
};

function base64ToFile(base64Data, filename) {
  const arr = base64Data.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}
function onSubmit()
{
  setSaveThemeButtonLoading(true)
  var headerFile = base64ToFile(header, "header.jpg")
  var logoFile = base64ToFile(logo, "logo.jpg")

  UpdateTheme(((theme === undefined || theme === null) ? null : theme.value), logo === "data:image/jpeg;base64,null" ? null : logoFile, header === "data:image/jpeg;base64,null" ? null : headerFile).then((res) => {
    notifySuccess("Theme Saved")
  }).catch((error) => {
    notifyError("Something went wrong, please try again or contact support")
  }).finally(()=> {
    setSaveThemeButtonLoading(false)
    props.getSite()
  })
}

function handleDeleteImage(imageType)
{
  DeleteImage(imageType).then((res) => {
    notifySuccess(imageType + " Deleted")
    if (imageType === "logo")
    {
      setLogo("data:image/jpeg;base64,null")
    }
    if (imageType === "header")
    {
      setHeader("data:image/jpeg;base64,null")
    }
  }).catch((error) => {
    notifyError("Something went wrong, please try again or contact support")
  }).finally(()=> {
    props.getSite()
  })
}


  return (
  <div className="upload-container">
    <ToastContainer />
    <div className="upload-block">
      <h3>Choose a theme</h3>
        <div className="theme-chooser">
          <Select
              placeholder="Start"
              closeMenuOnSelect={true}
              options={themes}
              onChange={(e) => {setTheme({value:e.value ,label: e.label})}}
              value={theme}
          />
        </div>
        <h3>Logo</h3>
        <div className="image-preview logo-preview">
          {logo !== "data:image/jpeg;base64,null" ? <img src={logo} alt="Logo" /> : null}
        </div>
        <div style={{display:"flex", alignItems:"center"}}>
        <label style={{marginRight:"0.5rem"}} className="upload-button">
          Upload Logo
          <input type="file" accept="image/*" onChange={(e) => {handleImageChange(e, 'logo'); e.target.value = null}} />
        </label>
        <button className="upload-button cancel-button mt-2" onClick={() => {handleDeleteImage("logo")}}>
            Delete
        </button>
        </div>
      </div>
      {/* HEADER */}
      <div className="upload-block">
        <h3>Header Image</h3>
        {header === "data:image/jpeg;base64,null" ? <p>If you choose not to upload a header image, a stock header image will be used instead</p> : <></>}
        <div className="image-preview header-preview">
          {header !== "data:image/jpeg;base64,null" ? <img src={header} alt="Header" /> : null}
        </div>
        <div style={{display:"flex", alignItems:"center"}}>
          <label style={{marginRight:"0.5rem"}} className="upload-button">
            Upload Header
            <input type="file" accept="image/*" onChange={(e) => {handleImageChange(e, 'header'); e.target.value = null}} />
          </label>
          <button className="upload-button cancel-button mt-2" onClick={() => {handleDeleteImage("header")}}>
            Delete
          </button>
        </div>
      </div>
      {/* CROPPER MODAL */}
      {imageSrc && (
        <div className="cropper-modal">
          <div className="cropper-wrapper">
            <Cropper
              image={imageSrc}
              crop={crop}
              zoom={zoom}
              aspect={croppingFor === "logo" ? 1 : 500 / 180}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
            />
            <div className="crop-controls">
                <button className="upload-button" onClick={handleCropDone}>
                    Crop
                </button>
                <button className="upload-button cancel-button" onClick={handleCropCancel}>
                    Cancel
                </button>
            </div>
          </div>
        </div>
      )}
      <button disabled={saveThemeButtonLoading} onClick={() => {onSubmit()}} className='save-button button'>
        {!saveThemeButtonLoading ?
        "Save Theme":
        <PulseLoader 
          color={'#eee'}
          loading={saveThemeButtonLoading}
          size={10}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
        }
        </button>
    </div>
    );
}

export default Theme;